import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import arrows_1 from 'assets/images/home/section_9/arrows_1.png';
import arrows_2 from 'assets/images/home/section_9/arrows_2.png';
import ActionButton from 'components/ui/buttons/action-button';
import { Link } from 'react-router-dom';
export default function Home__section__9() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__9">
            <div className="arrows arrows--left">
                <Animated animation={'animate__fadeInLeft animate__delay-1s'}>
                    <img src={arrows_1} />
                </Animated>
            </div>

            <div className="arrows arrows--right">
                <Animated animation={'animate__fadeInRight animate__delay-1s'}>
                    <img src={arrows_2} />
                </Animated>
            </div>

            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <h1>¿Te gustaría agendar una llamada?</h1>
                </Animated>

                <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                    <Link to="https://wa.me/5215531151431" target="_blank">
                        <ActionButton
                            text={'¡Quiero mi cita!'}
                            type="rounded"
                            color="cream-borders"
                            onClick={() => {
                                // dispatch(setDisplayModal(true));
                            }}
                        />
                    </Link>
                </Animated>
            </section>
        </main>
    );
}
